if (!customElements.get('paw-hero-slider')) {
  customElements.define(
    'paw-hero-slider',
    class PawHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.paw-hero__slide'));
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        // Theme editor: show the slide whose block is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) {
            this.paused = true;
            this.stop();
            this.go(i);
          }
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.paused = false;
          this.start();
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(i, fromUser) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.slides.forEach((slide, n) => {
          const active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        if (fromUser) this.start();
      }

      start() {
        this.stop();
        if (this.paused || this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const delay = (parseInt(this.dataset.speed, 10) || 6) * 1000;
        this.timer = setInterval(() => this.go(this.index + 1), delay);
      }

      stop() {
        clearInterval(this.timer);
      }
    }
  );
}
